import dniImg from "../src/images/dni-logo.jpg";
import ianImg from "../src/images/ian.jpg";

export const benefits = {
  en: {
    title: "Vorteile von News-Website Personalisierung",
    content: [
      {
        title: "Besseres Nachrichten-Erlebnis",
        type: "green",
        items: [
          "**Ideale Inhalte** ausgesteuert vom Algorithmus",
          "Leser finden leichter **Inhalte von Interesse**",
          "Content ausssteuern nach **Tageszeit**",
          "Content aussteuern nach **Standort**",
          "Lesern **verpassten Content** anzeigen",
          "Individuelle Inhalte zum **Horizonterweitern**",
        ],
      },
      {
        title: "Bessere Content Performance",
        type: "blue",
        items: [
          "**Wiederkehrrate** der Leser steigern",
          "**Click- und Lese-Raten** verbessern",
          "**Content-Lifecycle** verbessern",
          "**Traffic generieren** aus Lese-Historie",
          "**Teilen von Content** verbessern",
          "Homepage-Absprungrate **reduzieren**",
        ],
      },
      {
        title: "Gesteigerte Einnahmen",
        type: "orange",
        items: [
          "**Mehr Werbeeinnahmen** durch mehr Reichweite",
          "Bessere **Anzeigen-Clickrate** durch Relevanz",
          "Gesteigerte **Bezahl-Bereitschaft** fur Inhalte",
          "**Hochgradig zielgerichtet** hochpreisig verkaufen",
          "Mehr Inhalte verkaufen und **bezahlte Abos**",
          "**Direktmarketing** an registrierte Leser (Opt-In)",
        ],
      },
      {
        title: "Besserer Online-Journalismus",
        type: "red",
        items: [
          "**Reinvestieren in Content** durch Zusatzumsatz",
          "Mehr **Identifikation und Bindung** der Leser",
          "Effektiv spezielle **Zielgruppen** erreichen",
          "Daten in **On-Site-Optimierung** verwenden",
          "Gleichzeitig **mehrere Zielgruppen** erreichen",
          "Algorithmus **eigenen Vorstellungen anpassen**",
        ],
      },
    ],
  },
  de: {
    title: "Vorteile von News-Website Personalisierung",
    content: [
      {
        title: "Besseres Nachrichten-Erlebnis",
        type: "green",
        items: [
          "**Ideale Inhalte** ausgesteuert vom Algorithmus",
          "Leser finden leichter **Inhalte von Interesse**",
          "Content ausssteuern nach **Tageszeit**",
          "Content aussteuern nach **Standort**",
          "Lesern **verpassten Content** anzeigen",
          "Individuelle Inhalte zum **Horizonterweitern**",
        ],
      },
      {
        title: "Bessere Content Performance",
        type: "blue",
        items: [
          "**Wiederkehrrate** der Leser steigern",
          "**Click- und Lese-Raten** verbessern",
          "**Content-Lifecycle** verbessern",
          "**Traffic generieren** aus Lese-Historie",
          "**Teilen von Content** verbessern",
          "Homepage-Absprungrate **reduzieren**",
        ],
      },
      {
        title: "Gesteigerte Einnahmen",
        type: "orange",
        items: [
          "**Mehr Werbeeinnahmen** durch mehr Reichweite",
          "Bessere **Anzeigen-Clickrate** durch Relevanz",
          "Gesteigerte **Bezahl-Bereitschaft** fur Inhalte",
          "**Hochgradig zielgerichtet** hochpreisig verkaufen",
          "Mehr Inhalte verkaufen und **bezahlte Abos**",
          "**Direktmarketing** an registrierte Leser (Opt-In)",
        ],
      },
      {
        title: "Besserer Online-Journalismus",
        type: "red",
        items: [
          "**Reinvestieren in Content** durch Zusatzumsatz",
          "Mehr **Identifikation und Bindung** der Leser",
          "Effektiv spezielle **Zielgruppen** erreichen",
          "Daten in **On-Site-Optimierung** verwenden",
          "Gleichzeitig **mehrere Zielgruppen** erreichen",
          "Algorithmus **eigenen Vorstellungen anpassen**",
        ],
      },
    ],
  },
};

export const careers = {
  en: {
    title: "Join Our Distributed Team",
    tabs: [
      {
        title: "Remote-first",
        content: `
        <p>
          
          <a href="" rel="nofollow" target="_blank">
            remote-first
          </a> 
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
      {
        title: "Values",
        content: `
        <p>
          
          
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
    ],
  },
  de: {
    title: "Join Our Distributed Team",
    tabs: [
      {
        title: "Remote-first",
        content: `
        <p>
          
          <a href="" rel="nofollow" target="_blank">
            remote-first
          </a> 
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
      {
        title: "Values",
        content: `
        <p>
          
          
          
          
          
        </p>
        <p>
          
          
          
          
        </p>
      `,
      },
    ],
  },
};

export const examples = {
  en: {
    title: "Beispiele & Use Cases",
    tabs: [
      {
        title: "Personalisierungs-Kriterien",
        content: `
        <p>
          Ihre Leser generieren viele Daten. Der AKINGO News nutzt diese Daten um im Hintergrund personalisierte Versionen Ihrer Website zu generieren. Das gibt Ihren Lesern einfachen Zugriff auf deren individuell bevorzugte Inhalte, mit dem Ergebnis, dass diese eher mit den Inhalten interagieren, diese teilen, und ein Abo kaufen &mdash; was sich direkt auf die Erreichung Ihrer betriebswirtschaftlichen Ziele auswirkt.
        </p>
        <p>
          Leser erfreuen sich an benutzerspezifischen Versionen Ihrer News Website, da unsere Software Bewegungsdaten und allgemeine Daten verwendet um Inhalte dynamisch anzupassen. Leser sind auch in der Lage, selbst Content-Einstellungen vorzunehmen mittels einem in die Website integrierten Formular. Der Grad der Personalisierung kann dabei individuell anpasst werden, indem Themen selektiert werden, die der jeweilige leser mag oder von denen lieber weniger angezeigt werden soll.
        </p>
        <strong>
          Bewegungsdaten
        </strong>
        <ul>
          <li>Konsumiert oder ignoriert Inhalte bestimmer Themen, Rubriken oder Tags, beispielsweise
            ist denkbar, dass ein Leser oft die Politik-Rubrik besucht, aber niemals irgendwelche Sport-bezogenen Artikel aufruft (oder umgekehrt)</li>
          <li>Bevorzugt bestimmte Content-Typen wie z.B. Kurztexte, lange Artikel, Fotos oder Videos</li>
          <li>Konsumiert oder ignoriert Inhalte bestimmer Ersteller, bspw. Autoren oder Kolumnisten</li>
          <li>Interagiert mit bestimmten Inhalten durch Kommentieren, Teilen oder Liken</li>
          <li>Interagiert mit bestimmten Website-Features, bspw. meistgelesen oder meistgeteilte Inhalte</li>
          <li>Hat bestimmte Inhalte verpasst, weil die Website eine bestimmte Zeit nicht besucht wurde</li>
          <li>Bestimmte Verhaltensmuster, bspw. ein potentieller Jobsucher oder
            jemand mit einer angenommenen Markenbindung</li>
        </ul>
        <strong>
          Umgebungsdaten
        </strong>
        <ul>
          <li>Ort: basierend auf IP und/oder GPS</li>
          <li>Tageszeit: bspw. vor der Arbeit, Mittagspause, Feierabend oder Fahrt zur Arbeit</li>
          <li>Wochentag: Wochentag, Samstag oder Sonntag</li>
          <li>Wetter: bspw. Temperatur oder Regen und Schnee</li>
          <li>Datum: bspw. Jahreszeit, Feiertage und spezielle Ereignisse</li>
        </ul>

        <strong>
          Nutzerdaten
        </strong>
        <ul>
          <li>Selektiert aktiv bestimmte Rubriken oder Tags aus oder ab über die Einstellmöglichkeiten</li>
          <li>Reagiert auf Inhalte mit dem Like-Feature oder über Emojis</li>
          <li>Social Graph falls die News-Website Social-Nework-Features nutzt</li>
        </ul>
      `,
      },
      {
        title: "Inhalte anpassen",
        content: `
        <p>
          Unser Ziel ist es ein komplett neues digitales News-Erlebnis zu kreieren. AKINGO News kann Inhalte neu anordnen basierend darauf,
          was Individuen als relevant, interessant und wichtig
          erachten. Man kann aus unterschiedlichen Optionen selektieren, um eine ideale Zusammenstellung von Inhalten nach den Vorstellungen
         individueller Leser zu erreichen, wie beispielsweise:
        </p>
        <ul>
          <li>Individuelle Anordnung der von der Redaktion selektierten Inhalte.</li>
          <li>Austauschen von Inhalten, die ein Leser definitiv nicht konsumieren will.</li>
          <li>Teilweises oder komplettes Ersetzen von den Haupt-News des Tages.</li>
          <li>Unbeliebte Inhalte durch favorisierte Inhalte ersetzen, die ein Leser verpasst hat, weil die News Website einige Zeit nicht besucht wurde.</li>
          <li>Geolocation verwenden um besonders relevante Inhalte zum Standort des Leser anzuzeigen.</li>
          <li>Inhalte anzeigen je nach Tageszeit, bspw. leichtere Themen zum Tagesbeginn und wichtige globale Ereignisse in der Mittagszeit (oder umgekehrt).</li>
          <li>Unbeliebte Inhalte ersetzen durch relevante Stories, die sonst nicht auf die Startseite gekommen waren.</li>
          <li>Inhalte von bei einem Leser beliebten Autoren hervorherben und Inhalte unbeliebter Autoren eher verstecken.</li>
          <li>Inhalte anzeigen basierend auf dem Wochentag, bspw. Wirtschaftsnachrichten an Wochentagen und freizeitorientierte Inhalte am Wochenende.</li>
          <li>Bestimmte Inhalte nicht mehr auf der Startseite anzeigen, wenn der Leser sie zuvor ignoriert hat.</li>
        </ul>
      `,
      },
      {
        title: "Anordnung anpassen",
        content: `
        <p>
         Unser Ziel ist es ein komplett neues digitales News-Erlebnis zu kreieren. AKINGO News kann Inhalte
          neu anordnen basierend darauf, was Individuen als relevant, interessant
      und wichtig erachten. Man kann aus unterschiedlichen Optionen selektieren, um die ideale Zusammenstellung          von
          Inhalten für individuelle Leser zu erreichen, wie beispielsweise:
        </p>
        <ul>
          <li>Anordnen von Rubriken je nach Geschmack des LeAnordnen von Rubriken je nach Geschmack des Lesers, d.h. beliebte Inhalte in den unmittelbar sichtbaren Bereich der Website und unbeliebte Inhalte nach unten und weniger platzeinnehmend.ine store/paid subscription offers in the immediately visible area of the website if a reader shows a high brand affinity for the publisher (assuming their conversion rate for paid products is above average).</li>
          <li>Den Standort verwenden (falls dieser bekannt ist) um dem Leser mehr lokale Nachrichten im sofort sichtbaren Bereich anzuzeigen und gleichzeitig weniger relevante, ortsbezogene Inhalte reduzieren.</li>
          <li>Bestimmte Foto- und Videoinhalte in den sofort sichtbaren Bereich verlagern und dabei die Gewichtung und Anzahl von Content anpassen auf Basis der Nutzervorlieben, bspw. Fokus auf News-Clips oder eindrucksvolle Fotos des Tages, davon mehr zeigen.</li>
          <li>Die Bannerformate oder deren Gestaltung anpassen, beispielsweise bei relevanten Stellenanzeigen wenn anzunehmen ist, dass der Leser auf Jobsuche ist, und in den sofort sichtbaren Bereich verschieben.</li>
          <li>Website-Features wie z.B. die beliebtesten Inhalte (gelesen, kommentiert, geteilt) in Richtung des unmittelbar sichtbaren Bereichs verlagern, wenn der Leser diese gerne nutzt.</li>
          <li>Ungelesene Inhalte markieren, damit der Leser solchen Content direkt identifizieren kann.</li>
        </ul>
      `,
      },
    ],
  },
  de: {
    title: "Beispiele & Use Cases",
    tabs: [
      {
        title: "Personalisierungs-Kriterien",
        content: `
        <p>
          Ihre Leser generieren viele Daten. Der AKINGO News nutzt diese Daten um im Hintergrund personalisierte Versionen Ihrer Website zu generieren. Das gibt Ihren Lesern einfachen Zugriff auf deren individuell bevorzugte Inhalte, mit dem Ergebnis, dass diese eher mit den Inhalten interagieren, diese teilen, und ein Abo kaufen &mdash; was sich direkt auf die Erreichung Ihrer betriebswirtschaftlichen Ziele auswirkt.
        </p>
        <p>
          Leser erfreuen sich an benutzerspezifischen Versionen Ihrer News Website, da unsere Software Bewegungsdaten und allgemeine Daten verwendet um Inhalte dynamisch anzupassen. Leser sind auch in der Lage, selbst Content-Einstellungen vorzunehmen mittels einem in die Website integrierten Formular. Der Grad der Personalisierung kann dabei individuell anpasst werden, indem Themen selektiert werden, die der jeweilige leser mag oder von denen lieber weniger angezeigt werden soll.
        </p>
        <strong>
          Bewegungsdaten
        </strong>
        <ul>
          <li>Konsumiert oder ignoriert Inhalte bestimmer Themen, Rubriken oder Tags, beispielsweise
            ist denkbar, dass ein Leser oft die Politik-Rubrik besucht, aber niemals irgendwelche Sport-bezogenen Artikel aufruft (oder umgekehrt)</li>
          <li>Bevorzugt bestimmte Content-Typen wie z.B. Kurztexte, lange Artikel, Fotos oder Videos</li>
          <li>Konsumiert oder ignoriert Inhalte bestimmer Ersteller, bspw. Autoren oder Kolumnisten</li>
          <li>Interagiert mit bestimmten Inhalten durch Kommentieren, Teilen oder Liken</li>
          <li>Interagiert mit bestimmten Website-Features, bspw. meistgelesen oder meistgeteilte Inhalte</li>
          <li>Hat bestimmte Inhalte verpasst, weil die Website eine bestimmte Zeit nicht besucht wurde</li>
          <li>Bestimmte Verhaltensmuster, bspw. ein potentieller Jobsucher oder
            jemand mit einer angenommenen Markenbindung</li>
        </ul>
        <strong>
          Umgebungsdaten
        </strong>
        <ul>
          <li>Ort: basierend auf IP und/oder GPS</li>
          <li>Tageszeit: bspw. vor der Arbeit, Mittagspause, Feierabend oder Fahrt zur Arbeit</li>
          <li>Wochentag: Wochentag, Samstag oder Sonntag</li>
          <li>Wetter: bspw. Temperatur oder Regen und Schnee</li>
          <li>Datum: bspw. Jahreszeit, Feiertage und spezielle Ereignisse</li>
        </ul>

        <strong>
          Nutzerdaten
        </strong>
        <ul>
          <li>Selektiert aktiv bestimmte Rubriken oder Tags aus oder ab über die Einstellmöglichkeiten</li>
          <li>Reagiert auf Inhalte mit dem Like-Feature oder über Emojis</li>
          <li>Social Graph falls die News-Website Social-Nework-Features nutzt</li>
        </ul>
      `,
      },
      {
        title: "Inhalte anpassen",
        content: `
        <p>
          Unser Ziel ist es ein komplett neues digitales News-Erlebnis zu kreieren. AKINGO News kann Inhalte neu anordnen basierend darauf,
          was Individuen als relevant, interessant und wichtig
          erachten. Man kann aus unterschiedlichen Optionen selektieren, um eine ideale Zusammenstellung von Inhalten nach den Vorstellungen
         individueller Leser zu erreichen, wie beispielsweise:
        </p>
        <ul>
          <li>Individuelle Anordnung der von der Redaktion selektierten Inhalte.</li>
          <li>Austauschen von Inhalten, die ein Leser definitiv nicht konsumieren will.</li>
          <li>Teilweises oder komplettes Ersetzen von den Haupt-News des Tages.</li>
          <li>Unbeliebte Inhalte durch favorisierte Inhalte ersetzen, die ein Leser verpasst hat, weil die News Website einige Zeit nicht besucht wurde.</li>
          <li>Geolocation verwenden um besonders relevante Inhalte zum Standort des Leser anzuzeigen.</li>
          <li>Inhalte anzeigen je nach Tageszeit, bspw. leichtere Themen zum Tagesbeginn und wichtige globale Ereignisse in der Mittagszeit (oder umgekehrt).</li>
          <li>Unbeliebte Inhalte ersetzen durch relevante Stories, die sonst nicht auf die Startseite gekommen waren.</li>
          <li>Inhalte von bei einem Leser beliebten Autoren hervorherben und Inhalte unbeliebter Autoren eher verstecken.</li>
          <li>Inhalte anzeigen basierend auf dem Wochentag, bspw. Wirtschaftsnachrichten an Wochentagen und freizeitorientierte Inhalte am Wochenende.</li>
          <li>Bestimmte Inhalte nicht mehr auf der Startseite anzeigen, wenn der Leser sie zuvor ignoriert hat.</li>
        </ul>
      `,
      },
      {
        title: "Anordnung anpassen",
        content: `
        <p>
         Unser Ziel ist es ein komplett neues digitales News-Erlebnis zu kreieren. AKINGO News kann Inhalte
          neu anordnen basierend darauf, was Individuen als relevant, interessant
      und wichtig erachten. Man kann aus unterschiedlichen Optionen selektieren, um die ideale Zusammenstellung          von
          Inhalten für individuelle Leser zu erreichen, wie beispielsweise:
        </p>
        <ul>
          <li>Anordnen von Rubriken je nach Geschmack des Lesers, d.h. beliebte InhAnordnen von Rubriken je nach Geschmack des Lesers, d.h. beliebte Inhalte in den unmittelbar sichtbaren Bereich der Website und unbeliebte Inhalte nach unten und weniger platzeinnehmend.tion offers in the immediately visible area of the website if a reader shows a high brand affinity for the publisher (assuming their conversion rate for paid products is above average).</li>
          <li>Den Standort verwenden (falls dieser bekannt ist) um dem Leser mehr lokale Nachrichten im sofort sichtbaren Bereich anzuzeigen und gleichzeitig weniger relevante, ortsbezogene Inhalte reduzieren.</li>
          <li>Bestimmte Foto- und Videoinhalte in den sofort sichtbaren Bereich verlagern und dabei die Gewichtung und Anzahl von Content anpassen auf Basis der Nutzervorlieben, bspw. Fokus auf News-Clips oder eindrucksvolle Fotos des Tages, davon mehr zeigen.</li>
          <li>Die Bannerformate oder deren Gestaltung anpassen, beispielsweise bei relevanten Stellenanzeigen wenn anzunehmen ist, dass der Leser auf Jobsuche ist, und in den sofort sichtbaren Bereich verschieben.</li>
          <li>Website-Features wie z.B. die beliebtesten Inhalte (gelesen, kommentiert, geteilt) in Richtung des unmittelbar sichtbaren Bereichs verlagern, wenn der Leser diese gerne nutzt.</li>
          <li>Ungelesene Inhalte markieren, damit der Leser solchen Content direkt identifizieren kann.</li>
        </ul>
      `,
      },
    ],
  },
};

export const header = {
  en: {
    title: "News",
    subtitle: "Ihr Content kann mehr",
  },
  de: {
    title: "News",
    subtitle: "Ihr Content kann mehr",
  },
};

export const meta = {
  en: {
    title: "AKINGO - News Website Personalization",
    canonical: "https://capely.com/",
  },
  de: {
    title: "AKINGO - Personalisierung von News-Websites",
    canonical: "https://capely.com/de/akingo/",
  },
};

export const news = {
  en: {
    title: "Follow Our News Blog",
    content: `
    <p>
      
    </p>
    <ul>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  `,
  },
  de: {
    title: "Follow Our News Blog",
    content: `
    <p>
      
    </p>
    <ul>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  `,
  },
};

export const ourStory = {
  en: {
    title: "Unsere Story & Vision",
    content: [
      `
      <a class="OurStory__photo"
        href="https://www.linkedin.com/in/ianflorian"
        target="_blank"
        rel="nofollow"
      >
        <img src="${ianImg}" alt="Florian Scheel" />
      </a>
      <p>
        AKINGO, heute Capely, wurde 2013 von <a href="https://www.linkedin.com/in/ianflorian" target="_blank" rel="nofollow"> Florian Scheel</a> als Beratung
        mit Schwerpunkt Web bzw. Digital Analytics, a/b/n-Testing, Conversion-Rate-Optimierung,
        Personalisierung und Datenanlyse. Seither wurden in einer Vielzahl von Branchen Beratungsprojekte abgeschlossen:
        Reise, Marketing, Energie, Transport, Handel, Versicherungen und Lotterien.
        Vor dem Start des Unternehmens hat Florian Wirtschaft und BWL studiert. Zur Finanzierung
        des Studiums hat er zwei werbefinanzierte Online-Magazine aufgebaut. Im Anschluss hat er dann bei einem traditionsreichen deutschen Verlag
        das Gebiet Web Analytics verantwortet.
        Seine Liebe zum Online-Journalismus blieb aber, sodass er 2016 beschloss, die Beratung aufzugeben und eine Software zu entwickeln,
        die Publishern dabei helfen soll, online erfolgreicher zu sein. Um AKINGO News umzusetzen,
        stellte er ein Team von Technologiebegeisterten zusammen.
      </p>
      <p>
        <strong>Unsere Vision ist es, Online-Publishern zu einer starken Marktposition zu verhelfen.</strong>
      </p>
    `,
      `
      <a class="OurStory__floatBottomBlock"
        href="https://newsinitiative.withgoogle.com"
        target="_blank"
        rel="nofollow"
      ><img src="${dniImg}" alt="Digital News Initiative Logo" /></a>
      Obwohl Content immer noch King ist, tun sich viele Verlage weiterhin schwer,
      ihren Journalismus mit Online-Werbung und Abos zu finanzieren. Die derzeit erfolgreichste Content-Plattform der Welt
      ist auch gleichzeitig das erfolgreichste soziale Netzwerk. Facebook ist so erfolgreich, weil der Kern ein hochgradig
      personalisierter Feed ist, der Benutzer in ihren Bann zieht.
      In genau dieser Weise, dynamisiert AKINGO News traditionelle News-Websites um ein besonders fesselndes Leseerlebnis zu
     kreieren.
      Mit unserer Technologie schlagen wir einen ganz neuen Weg ein und wollen jedem Leser in de Lage versetzen,
      die Inhalte zu konsumieren, die sie wirklich lesen und teilen wollen.
      Mit unserer CMS-agnostischen Software stellen wir News-Publishern ein Tool bereit, um ihre Profitabilitat zu verbessern.
      Wir sind sehr stolz und super dankbar, dass unsere Vision geteilt wird von der 
      <a href="https://newsinitiative.withgoogle.com/dnifund/dni-projects/akingo/" target="_blank" rel="nofollow">Google Digital News Initiative</a>, welche Geld an innovative Projekte gibt, die einen Beitrag zur Wirtschaftlichkeit von Online-Journalismus leisten.
    `,
    ],
  },
  de: {
    title: "Unsere Story & Vision",
    content: [
      `
      <a class="OurStory__photo"
        href="https://www.linkedin.com/in/ianflorian"
        target="_blank"
        rel="nofollow"
      >
        <img src="${ianImg}" alt="Florian Scheel" />
      </a>
      <p>
        AKINGO, heute Capely, wurde 2013 von <a href="https://www.linkedin.com/in/ianflorian" target="_blank" rel="nofollow"> Florian Scheel</a> als Beratung
        mit Schwerpunkt Web bzw. Digital Analytics, a/b/n-Testing, Conversion-Rate-Optimierung,
        Personalisierung und Datenanlyse. Seither wurden in einer Vielzahl von Branchen Beratungsprojekte abgeschlossen:
        Reise, Marketing, Energie, Transport, Handel, Versicherungen und Lotterien.
        Vor dem Start des Unternehmens hat Florian Wirtschaft und BWL studiert. Zur Finanzierung
        des Studiums hat er zwei werbefinanzierte Online-Magazine aufgebaut. Im Anschluss hat er dann bei einem traditionsreichen deutschen Verlag
        das Gebiet Web Analytics verantwortet.
        Seine Liebe zum Online-Journalismus blieb aber, sodass er 2016 beschloss, die Beratung aufzugeben und eine Software zu entwickeln,
        die Publishern dabei helfen soll, online erfolgreicher zu sein. Um AKINGO News umzusetzen,
        stellte er ein Team von Technologiebegeisterten zusammen.
      </p>
      <p>
        <strong>Unsere Vision ist es, Online-Publishern zu einer starken Marktposition zu verhelfen.</strong>
      </p>
    `,
      `
      <a class="OurStory__floatBottomBlock"
        href="https://newsinitiative.withgoogle.com"
        target="_blank"
        rel="nofollow"
      ><img src="${dniImg}" alt="Digital News Initiative Logo" /></a>
      Obwohl Content immer noch King ist, tun sich viele Verlage weiterhin schwer,
      ihren Journalismus mit Online-Werbung und Abos zu finanzieren. Die derzeit erfolgreichste Content-Plattform der Welt
      ist auch gleichzeitig das erfolgreichste soziale Netzwerk. Facebook ist so erfolgreich, weil der Kern ein hochgradig
      personalisierter Feed ist, der Benutzer in ihren Bann zieht.
      In genau dieser Weise, dynamisiert AKINGO News traditionelle News-Websites um ein besonders fesselndes Leseerlebnis zu
     kreieren.
      Mit unserer Technologie schlagen wir einen ganz neuen Weg ein und wollen jedem Leser in de Lage versetzen,
      die Inhalte zu konsumieren, die sie wirklich lesen und teilen wollen.
      Mit unserer CMS-agnostischen Software stellen wir News-Publishern ein Tool bereit, um ihre Profitabilitat zu verbessern.
      Wir sind sehr stolz und super dankbar, dass unsere Vision geteilt wird von der 
      <a href="https://newsinitiative.withgoogle.com/dnifund/dni-projects/akingo/" target="_blank" rel="nofollow">Google Digital News Initiative</a>, welche Geld an innovative Projekte gibt, die einen Beitrag zur Wirtschaftlichkeit von Online-Journalismus leisten.
    `,
    ],
  },
};

export const slider = {
  en: {
    title: "News",
  },
  de: {
    title: "News",
  },
};

export const solution = {
  en: {
    title: "<span>Make Your News Site</span> More Profitable",
    subtitle:
      "<span>create personalized experiences,</span> seamless for readers",
    leftHint: "Ihre Leser",
    rightHint: "Ihre Inhalte",
  },
  de: {
    title:
      "Steigern Sie die <span>Profitabilit&auml;t</span> Ihrer News-Website",
    subtitle:
      "<span>Personalisierte Inhalte,</span> ohne Nachteile f&uuml;r die Leser",
    leftHint: "Ihre Leser",
    rightHint: "Ihre Inhalte",
  },
};

export const technology = {
  en: {
    title: "Unsere Personalisierungs-Technologie",
    schemeTab: {
      title: "In der Cloud",
      description: {
        title: "Wissenswertes zu AKINGO News",
        content: `
        <ul>
          <li>
            Sicher gehostet auf der Google Cloud Platform.
          </li>
          <li>
            Kompatibel mit globalen CDNs, bspw. Cloudflare.
          </li>
          <li>
            Komplett unbemerkt von Ihren Lesern.
          </li>
          <li>
            Fail-Safe-Architektur mit Backup.
          </li>
        </ul>
      `,
      },
      warningMessage: `
      <strong>Warnung:</strong>
      Um unsere Visualisierung zu sehen, besuchen Sie unsere Website bitte mit einer hohen Auflosung
    `,
      schemeBoxes: {
        green: { title: "Ihre Leser" },
        orange: {
          title: "CDN, e.g. Cloudflare",
          content: `<ul>
          <li>Globales Netzwerk</li>
          <li>Caching</li>
          <li>Request-Routing</li>
        </ul>`,
        },
        blue: {
          title: "AKINGO News",
          content: `<ul>
          <li>Personalisierung</li>
          <li>Datenerfassung</li>
          <li>User Interface</li>
        </ul>`,
        },
        red: { title: "Ihr CMS" },
      },
      hints: [
        {
          content: `
          <div>Zugriffe auf</div>
          <div>Ihre Domain</div>
        `,
        },
        {
          content: `
          <div>Abruf von</div>
          <div><i>Personalisierten Inhalten</i></div>
        `,
        },
        {
          content: `
          <div>Abruf von</div>
          <div><i>Standard-Content</i></div>
          <div>+ Failover</div>
        `,
        },
        {
          content: `
          <div>Abruf von</div>
          <div>Ihrem Content</div>
          <div>(Crawler / API)</div>
        `,
        },
      ],
    },
    tabs: [
      {
        title: "On Premise",
        content: `
        Auch wenn wir die Cloud bevorzugen, kann unsere Software auch auf Ihren Servern installiert werden,
        d.h. On-Premises oder mittels Co-Location. Unsere Software besteht aus Dutzenden Microservices
        und sollte sich problemlos in Ihre Systemlandschaft integrieren lassen. Falls Sie Interesse
        an unserer On-Premises-Software haben, kontaktieren Sie uns bitte um die Anforderungen abzustimmen.
        Unser derzeitiger Technologie-Stack umfasst:

        <ul>
          <li>
            Golang auf Unix
          </li>
          <li>
            Node.js auf Unix
          </li>
          <li>
            Varnish/Nginx auf Unix
          </li>
        </ul>
      `,
      },
    ],
  },
  de: {
    title: "Unsere Personalisierungs-Technologie",
    schemeTab: {
      title: "In der Cloud",
      description: {
        title: "Wissenswertes zu AKINGO News",
        content: `
        <ul>
          <li>
            Sicher gehostet auf der Google Cloud Platform.
          </li>
          <li>
            Kompatibel mit globalen CDNs, bspw. Cloudflare.
          </li>
          <li>
            Komplett unbemerkt von Ihren Lesern.
          </li>
          <li>
            Fail-Safe-Architektur mit Backup.
          </li>
        </ul>
      `,
      },
      warningMessage: `
      <strong>Warnung:</strong>
      Um unsere Visualisierung zu sehen, besuchen Sie unsere Website bitte mit einer hohen Auflosung
    `,
      schemeBoxes: {
        green: { title: "Ihre Leser" },
        orange: {
          title: "CDN, e.g. Cloudflare",
          content: `<ul>
          <li>Globales Netzwerk</li>
          <li>Caching</li>
          <li>Request-Routing</li>
        </ul>`,
        },
        blue: {
          title: "AKINGO News",
          content: `<ul>
          <li>Personalisierung</li>
          <li>Datenerfassung</li>
          <li>User Interface</li>
        </ul>`,
        },
        red: { title: "Ihr CMS" },
      },
      hints: [
        {
          content: `
          <div>Zugriffe auf</div>
          <div>Ihre Domain</div>
        `,
        },
        {
          content: `
          <div>Abruf von</div>
          <div><i>Personalisierten Inhalten</i></div>
        `,
        },
        {
          content: `
          <div>Abruf von</div>
          <div><i>Standard-Content</i></div>
          <div>+ Failover</div>
        `,
        },
        {
          content: `
          <div>Abruf von</div>
          <div>Ihrem Content</div>
          <div>(Crawler / API)</div>
        `,
        },
      ],
    },
    tabs: [
      {
        title: "On Premise",
        content: `
        Auch wenn wir die Cloud bevorzugen, kann unsere Software auch auf Ihren Servern installiert werden,
        d.h. On-Premises oder mittels Co-Location. Unsere Software besteht aus Dutzenden Microservices
        und sollte sich problemlos in Ihre Systemlandschaft integrieren lassen. Falls Sie Interesse
        an unserer On-Premises-Software haben, kontaktieren Sie uns bitte um die Anforderungen abzustimmen.
        Unser derzeitiger Technologie-Stack umfasst:

        <ul>
          <li>
            Golang auf Unix
          </li>
          <li>
            Node.js auf Unix
          </li>
          <li>
            Varnish/Nginx auf Unix
          </li>
        </ul>
      `,
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./_content.js